import creator from "./creator";
import select from "./select";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-selection/src/create.js
// module id = ../../../../d3-selection/src/create.js
// module chunks = 4